module.exports = __webpack_public_path__ + "static/img/xlsx2.53eeb901.svg";